// extracted by mini-css-extract-plugin
export default {"body":"ConfirmationModal__body___aEgNg","message":"ConfirmationModal__message___LWsqT","error":"ConfirmationModal__error___kmBMn","footer":"ConfirmationModal__footer___tTRkA"};